import React, { useCallback, useEffect } from 'react';
import { Player, playersApi } from '../../api';

async function loadPlayers(
  setPlayers: (players: Player[]) => void,
  setLastUpdatedAt: (updatedAt: number) => void
) {
  const players = await playersApi.list();
  setPlayers(players);
  setLastUpdatedAt(Date.now());
}

export function usePlayers() {
  const [players, setPlayers] = React.useState<Player[]>([]);
  const [lastUpdatedAt, setLastUpdatedAt] = React.useState(Date.now());
  const didPlayersLoadingRef = React.useRef(false);

  const removePlayer = useCallback(
    async (player: Player) => {
      await playersApi.removePlayer(player.name);
      await loadPlayers(setPlayers, setLastUpdatedAt);
    },

    [setPlayers, setLastUpdatedAt]
  );

  const addPlayer = useCallback(
    async (player: Player) => {
      await playersApi.addPlayer(player);
      await loadPlayers(setPlayers, setLastUpdatedAt);
    },
    [setPlayers, setLastUpdatedAt]
  );

  useEffect(() => {
    if (didPlayersLoadingRef.current) {
      return;
    }
    didPlayersLoadingRef.current = true;
    loadPlayers(setPlayers, setLastUpdatedAt);
  }, []);

  return {
    lastUpdatedAt,
    players,
    removePlayer,
    addPlayer,
    setPlayers,
  };
}
